import React from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { setSelectedLocationId } from "redux/index";
import Collapse from "@mui/material/Collapse";
import makeStyles from "@mui/styles/makeStyles";
import SomuraDataGrid from "Components/SomuraDataGrid";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import LocationsForm from "./LocationsForm"

const useStyles = makeStyles((theme) => ({
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

const mapStateToProps = (state) => {
  const locations = state.articles.Locations;
  const selectedId = state.articles.selectedLocationId;
  return { locations, selectedId };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setId: (id) => dispatch(setSelectedLocationId(id)),
  };
};

function LocationsTable({ locations, selectedId, setId }) {
  const classes = useStyles();
  const { t } = useTranslation();

  const columns = [
    {
      headerName: "",
      headerClassName: "tableHeader",
      field: "id",
      hide: true,
      filterable: false,
    },
    {
      headerName: t("Name"),
      headerClassName: "tableHeader",
      field: "locationName",
      flex: 0.2,
    },
    {
      headerName: t("Belongs to"),
      headerClassName: "tableHeader",
      field: "parentLocationName",
      flex: 0.2,
    },
  ];

  const rows = locations?.map((L) => ({
    id: L.id,
    locationName: L.locationName,
    parentLocationName: L.parentLocationName,
  }));

  const handleRowClick = (params) => {
    setId(params);
  };

  const handleCreate = () => {
    setId(0)
  }

  return (
    <>
      <Collapse in={selectedId < 0} timeout={"auto"}>
        <SomuraDataGrid
          tableHeight={"calc(100vh - 260px)"}
          rows={rows}
          columns={columns}
          defaultSortModel={[
            {
              field: "locationName",
              sort: "asc",
            },
          ]}
          onRowClick={(params) => handleRowClick(params)}
          csvFileName={t("Locations")}
        />
        <Fab
          variant="extended"
          color="primary"
          size="medium"
          className={classes.fab}
          onClick={handleCreate}
        >
          <AddIcon />
          {t("New location")}
        </Fab>
      </Collapse>
      <Collapse in={selectedId >= 0} timeout={"auto"}>
        <LocationsForm />
      </Collapse>
    </>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LocationsTable);
